import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { obrigatorio, senhaMinima } from '@/shareds/regras'
import { auth } from '@/firebase'
import { loginFirebase } from '@/services/AuthService'
import { alert, authModule } from '@/store'
import { useRoute, useRouter } from '@/composables/router'

// o Firebase manda para esta página (URL de ação do console) os links de todos os e-mails de conta

export default /*#__PURE__*/_defineComponent({
  __name: 'AcaoDeConta',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const form = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

const codigo = String(route.query.oobCode ?? '')
const confirmacaoDeEmail = route.query.mode === 'verifyEmail'
const verificando = ref(true)
const linkInvalido = ref(false)
const carregando = ref(false)
const verSenha = ref(false)
const email = ref('')
const senha = ref('')
const confirmarSenha = ref('')

function coincidirSenhas(confirmacao: unknown) {
	return confirmacao === senha.value || 'Senhas não coincidem'
}

onMounted(async () => {
	try {
		if (!codigo) throw new Error('Link sem código')
		if (confirmacaoDeEmail) {
			const { data } = await auth.checkActionCode(codigo)
			email.value = data.email ?? ''
			await auth.applyActionCode(codigo)
		} else {
			email.value = await auth.verifyPasswordResetCode(codigo)
		}
	} catch {
		linkInvalido.value = true
	} finally {
		verificando.value = false
	}
})

async function definirSenha() {
	if (!form.value!.validate()) return
	try {
		carregando.value = true
		await auth.confirmPasswordReset(codigo, senha.value)
		const { user } = await auth.signInWithEmailAndPassword(email.value, senha.value)
		const { data } = await loginFirebase({ idToken: await user!.getIdToken(), senha: senha.value })
		await authModule.logarToken(data)
		router.push({ name: 'home' })
			.catch(() => {})
	} catch (error) {
		const codigoDoErro = (error as { code?: string }).code
		if (codigoDoErro === 'auth/expired-action-code' || codigoDoErro === 'auth/invalid-action-code') {
			linkInvalido.value = true
			return
		}
		if (codigoDoErro === 'auth/weak-password') {
			alert.setError('A senha deve ter pelo menos 6 caracteres')
			return
		}
		alert.setError(error)
	} finally {
		carregando.value = false
	}
}

return { __sfc: true,route, router, form, codigo, confirmacaoDeEmail, verificando, linkInvalido, carregando, verSenha, email, senha, confirmarSenha, coincidirSenhas, definirSenha, ContainerCenter, obrigatorio, senhaMinima }
}

})